import PropTypes from 'prop-types';

const displayName = 'Modal';
const propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
const defaultProps = {
  visible: false,
};

export default { displayName, propTypes, defaultProps };
